<template>
  <SnackBar ref="snackbar" />
  <v-dialog v-model="dialog" max-width="850px">
    <template #activator="{ props }">
      <div class="mx-auto" style="text-decoration: none; color: inherit">
        <v-hover>
          <v-card
            v-bind="props"
            class="pointer text-center"
            height="100px"
            width="140px"
          >
            <v-icon
              class="mt-3"
              size="x-large"
              icon="mdi-format-list-group-plus"
            />
            <v-card-text class="pt-0"> Nova Avaliação </v-card-text>
          </v-card>
        </v-hover>
      </div>
    </template>
    <v-card height="680">
      <v-card-title>
        <span class="text-h5">Nova Avaliação</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="tituloAvaliacao"
                variant="underlined"
                label="Título*"
                hint="Utilize apenas letras, números, '-' e/ou '_' para o título da avaliação"
                counter
                maxlength="68"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                v-model="projetosSelecionados"
                :items="listaProjetos"
                item-title="nome"
                item-value="idproj"
                multiple
                chips
                closable-chips
                label="Projetos*"
                hint="Escolha os projetos para associar esta avaliação"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row
            ><v-col cols="12" sm="6" md="6">
              <p>
                Selecione o tipo de Avaliação*
                <v-tooltip
                  text="Marque uma das opções de avaliação ou as duas, 
                    se for o caso.
                    "
                >
                  <template #activator="{ props }">
                    <span v-bind="props" class="mdi mdi-information"></span>
                  </template>
                </v-tooltip>
              </p> </v-col
          ></v-row>
          <v-row>
            <v-col>
              <v-checkbox-btn
                v-model="checkedQualitativa"
                class="pe-2"
                label="Qualitativa"
              ></v-checkbox-btn>
              <v-checkbox-btn
                v-model="checkedIndividual"
                label="Individual"
              ></v-checkbox-btn>
            </v-col>
            <v-col
              ><v-select
                v-model="formSelecionado"
                :items="formularios"
                item-value="id"
                item-title="nome"
                density="comfortable"
                :disabled="!checkedQualitativa"
                label="Formulários*"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <p>Começo da Avaliação*</p>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <p>Fim da Avaliação*</p>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <VueDatePicker
                v-model="dtInicio"
                auto-apply
                :min-date="new Date()"
                :enable-time-picker="false"
                :format="dtInicio != null ? format(dtInicio) : ''"
              />
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <VueDatePicker
                v-model="dtFim"
                auto-apply
                :min-date="dtInicio"
                :enable-time-picker="false"
                :format="dtFim != null ? format(dtFim) : ''"
              ></VueDatePicker>
            </v-col>
          </v-row>
        </v-container>
        <small>*Campos obrigatórios</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" variant="text" @click="dialog = false">
          Cancelar
        </v-btn>
        <v-btn color="blue-darken-1" variant="text" @click="cadastrar()">
          Cadastrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import axios from 'axios';

import '@vuepic/vue-datepicker/dist/main.css';
import SnackBar from '@/components/SnackBar.vue';
import store from '@/store/store';
const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  components: { VueDatePicker, SnackBar },
  props: {
    idProjeto: {
      type: Number,
      default: null,
    },
    nomeProjetoTitulo: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      dialog: false,
      tituloAvaliacao: '',
      dtInicio: new Date(),
      dtFim: new Date(),
      checkedQualitativa: false,
      checkedIndividual: false,
      formularios: [],
      nomesFormularios: [],
      formSelecionado: null,
      projetosSelecionados: [],
      listaProjetos: [],
    };
  },

  created() {
    this.fetchForms();
    this.fetchprojetos();
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  methods: {
    fetchprojetos() {
      axios
        .get(API_URL + '/projetos/COORDENADOR', {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          response.data.forEach((element) => {
            /* eslint-disable */
            element.fl_coordenador === true
              ? (element.fl_coordenador = 'Coordenador')
              : (element.fl_coordenador = 'Desenvolvedor');
            /* eslint-enable */
            if (element.flencerrado != true) {
              this.listaProjetos.push({
                idproj: element.id_projeto,
                // sigla: element.sigla,
                nome: element.nome,
              });
            }
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },

    /* eslint-disable */
    /**
     * Função para cadastrar o tipo de avaliação selecionado
     * @function
     * @name cadastrar
     * @memberof CreatingRating
     * @returns {Promise<void>}
     */
    cadastrar() {
      // Permite letras maiúsculas e minúsculas com e sem acento,
      // números, espaços, o caractere "ç", "-", e "_".
      if (
        this.tituloAvaliacao.replace(/[^a-zA-ZÀ-ÖØ-öø-ÿ0-9\sçÇ\-_]/g, '') ===
        this.tituloAvaliacao
      ) {
        if (
          this.tituloAvaliacao != '' &&
          this.dtInicio != null &&
          this.dtFim != null &&
          this.projetosSelecionados.length != 0
        ) {
          if (this.dtInicio < this.dtFim) {
            if (this.checkedQualitativa && this.checkedIndividual) {
              // Ambos os checkboxes estão marcados
              if (this.formSelecionado != null) {
                this.cadastrarAvaliacaoAmbas();
              } else {
                this.$refs.snackbar.showWarningSnackbar(
                  'Formulário não selecionado!',
                  'Por favor, selecione um formulário para fazer parte da avaliação!'
                );
              }
            } else if (this.checkedIndividual) {
              // Apenas o checkbox "individual" está marcado
              this.cadastrarAvaliacaoIndivual();
            } else if (this.checkedQualitativa) {
              if (this.formSelecionado != null) {
                // Apenas o checkbox "qualitativa" está marcado
                this.cadastrarAvaliacaoQualitativa();
              } else {
                this.$refs.snackbar.showWarningSnackbar(
                  'Formulário não selecionado!',
                  'Por favor, selecione um formulário para fazer parte da avaliação!'
                );
              }
            } else {
              this.$refs.snackbar.showWarningSnackbar(
                'Campos vazios!',
                'Por favor, selecione um tipo de avaliação!'
              );
            }
          } else {
            this.$refs.snackbar.showWarningSnackbar(
              'Datas inválidas!',
              'Data inicial maior que final. Por favor, preencha-as corretamente!'
            );
          }
        } else {
          this.$refs.snackbar.showWarningSnackbar(
            'Campos vazios!',
            'Por favor, preencha todos os campos obrigatórios!'
          );
        }
      } else {
        this.$refs.snackbar.showWarningSnackbar(
          'Título inválido!',
          'Por favor, digite um nome válido para avaliação.'
        );
      }
    },

    /* eslint-disable */
    /**
     * Função para cadastrar avaliações que são individuais
     * @function
     * @name cadastrarAvaliacaoIndivual
     * @memberof CreatingRating
     * @returns {Promise<void>}
     */
    cadastrarAvaliacaoIndivual() {
      // transformando em um array de json de ids de projetos, formato solicitado pelo back
      const projSelecionados = [];
      for (const element of this.projetosSelecionados) {
        // eslint-disable-next-line camelcase
        const itemJson = { id_projeto: element };
        projSelecionados.push(itemJson);
      }

      const data = {
        titulo: this.tituloAvaliacao,
        dtinicio: this.dtInicio.toISOString().replace(/\.\d{3}Z$/, 'Z'),
        dtfim: this.dtFim.toISOString().replace(/\.\d{3}Z$/, 'Z'),
        projetos: projSelecionados,
      };
      const config = {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        },
      };
      axios
        .post(API_URL + '/avaliacoes', data, config)
        .then(() => {
          this.$refs.snackbar.showSuccessSnackbar(
            'Concluído!',
            'Avaliação Individual cadastrada com sucesso!'
          );
          this.dialog = false;
          this.dtInicio = new Date();
          this.dtFim = new Date();
          this.projetosSelecionados = [];
          location.reload();
        })
        .catch((error) => {
          this.dtInicio = new Date();
          this.dtFim = new Date();
          console.log(error.response.data.error);
          this.$refs.snackbar.showErrorSnackbar(
            'Hm... Algo deu errado',
            'Por algum motivo, não conseguimos registrar sua avaliação!'
          );
        });
    },

    /* eslint-disable */
    /**
     * Função para cadastrar avaliações que são qualitativas
     * @function
     * @name cadastrarAvaliacaoQualitativa
     * @memberof CreatingRating
     * @returns {Promise<void>}
     */
    cadastrarAvaliacaoQualitativa() {
      const projSelecionados = [];
      console.log(this.projetosSelecionados);
      for (const element of this.projetosSelecionados) {
        // eslint-disable-next-line camelcase
        const itemJson = { id_projeto: element };
        projSelecionados.push(itemJson);
      }

      const data = {
        titulo: this.tituloAvaliacao,
        dtinicio: this.dtInicio.toISOString().replace(/\.\d{3}Z$/, 'Z'),
        dtfim: this.dtFim.toISOString().replace(/\.\d{3}Z$/, 'Z'),
        id_formulario: this.formSelecionado,
        projetos: projSelecionados,
      };
      const config = {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        },
      };
      axios
        .post(API_URL + '/avaliacoes/formulario', data, config)
        .then(() => {
          this.$refs.snackbar.showSuccessSnackbar(
            'Concluído!',
            'Avaliação Qualitativa cadastrada com sucesso!'
          );
          this.dialog = false;
          this.dtInicio = new Date();
          this.dtFim = new Date();
          this.projetosSelecionados = [];
          location.reload();
        })
        .catch((error) => {
          this.dtInicio = new Date();
          this.dtFim = new Date();
          console.log(error.response.data.error);
          console.log(this.projSelecionados);
          console.log(this.formSelecionado);
          this.$refs.snackbar.showErrorSnackbar(
            'Hm... Algo deu errado',
            'Por algum motivo, não conseguimos registrar sua avaliação!'
          );
        });
    },
    /* eslint-disable */
    /**
     * Função para cadastrar avaliações que são qualitativas e individuais
     * @function
     * @name cadastrarAvaliacaoAmbas
     * @memberof CreatingRating
     * @returns {Promise<void>}
     */
    cadastrarAvaliacaoAmbas() {
      const projSelecionados = [];
      for (const element of this.projetosSelecionados) {
        // eslint-disable-next-line camelcase
        const itemJson = { id_projeto: element };
        projSelecionados.push(itemJson);
      }

      const data = {
        titulo: this.tituloAvaliacao,
        dtinicio: this.dtInicio.toISOString().replace(/\.\d{3}Z$/, 'Z'),
        dtfim: this.dtFim.toISOString().replace(/\.\d{3}Z$/, 'Z'),
        id_formulario: this.formSelecionado,
        projetos: projSelecionados,
      };
      const config = {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        },
      };
      axios
        .post(API_URL + '/avaliacoes/formulario', data, config)
        .then(() => {
          this.$refs.snackbar.showSuccessSnackbar(
            'Concluído!',
            'Avaliação cadastrada com sucesso!'
          );
          this.dialog = false;
          this.dtInicio = new Date();
          this.dtFim = new Date();
          location.reload();
        })
        .catch((error) => {
          this.dtInicio = new Date();
          this.dtFim = new Date();
          console.log(error.response.data.error);
          this.$refs.snackbar.showErrorSnackbar(
            'Hm... Algo deu errado',
            'Por algum motivo, não conseguimos registrar sua avaliação!'
          );
        });
    },

    format(date) {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
    },

    /* eslint-disable */
    /**
     * Busca a lista de formulários a partir do backend e preenche o array de formulários
     * @function
     * @name fetchForms
     * @memberof CreatingRating
     * @returns {Promise<void>}
     */
    fetchForms() {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${store.state.token}`,
        },
      };

      axios
        .get(API_URL + '/avaliacoes/formulario', config)
        .then((response) => {
          this.formularios = response.data.map((formulario) => ({
            id: formulario.id_formulario,
            nome: formulario.titulo,
          }));
          console.log(this.formularios);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    close() {
      this.dialog = false;
      this.tituloAvaliacao = '';
      this.dtInicio = new Date();
      this.dtFim = new Date();
      this.checkedQualitativa = false;
      this.checkedIndividual = false;
    },
  },
};
</script>
